import { useReadContract } from 'wagmi'
import { P2P_ESCROW_ABI } from '../lib/p2p/abi'
import {
  escrowAddressForChain,
  infoForSide,
  P2POrderSide,
} from '../lib/p2p/tokens'

export interface MinOrderAmountResult {
  minWei: bigint | null
  isLoading: boolean
}

// `minOrderAmount` se gobierna on-chain; sin esto el frontend dejaba enviar
// órdenes por debajo del mínimo y el contrato revertía con AmountTooSmall.
// WalletConnect oculta el revert real bajo "Request expired", por eso
// bloqueamos en cliente antes de firmar.
export function useP2PMinOrderAmount(side: P2POrderSide): MinOrderAmountResult {
  const info = infoForSide(side)
  const { data, isLoading } = useReadContract({
    address: escrowAddressForChain(info.chain),
    abi: P2P_ESCROW_ABI,
    functionName: 'minOrderAmount',
    chainId: info.chainId,
    query: { staleTime: 60_000 },
  })

  return {
    minWei: data == null ? null : BigInt(data as bigint | number | string),
    isLoading,
  }
}
